/**
 * JobsListRoute — skin-aware switcher for /jobs.
 * Cockpit → JobsListCockpit · Classic → original JobsList
 */
import { useUISkin } from "@/data/UISkinContext";
import JobsList from "./JobsList";
import JobsListCockpit from "./JobsListCockpit";

export default function JobsListRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <JobsListCockpit />;
  return <JobsList />;
}
